import { SupportMessageTags } from '@website/types/graphqlOperations';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { Store } from '../../Store';
import HelpButton from './HelpButton';
import ContactForm from './sections/contactForm/ContactForm';
import ExistingBooking from './sections/existingBookings/ExistingBookings';
import NewTrip from './sections/newTrip/NewTrip';

/**
 * Help flow
 *
 * A series of buttons to get to the correct help page
 */
export default function HelpFlow() {
  const { state } = useContext(Store);

  const { query } = useRouter();

  const tripTitle = query.tripTitle as string;

  const [currentActiveKey, setActiveKey] = useState<string>();
  const buttonProps = { currentActiveKey, setActiveKey };

  useEffect(() => {
    if (tripTitle) {
      setActiveKey('newTrip');
    }
  }, [tripTitle]);

  return (
    <div>
      <h1>
        How can we help you today
        {state.user?.first_name ? ` ${state.user.first_name}` : ''}?
      </h1>

      <Row className="mt-4">
        <HelpButton
          {...buttonProps}
          activeKey="existing"
          text="An existing Booking"
        >
          <ExistingBooking />
        </HelpButton>

        <HelpButton
          {...buttonProps}
          activeKey="newTrip"
          text="A trip I'm interested in"
        >
          <NewTrip tripTitle={tripTitle} />
        </HelpButton>

        <HelpButton {...buttonProps} activeKey="other" text="Something else">
          <ContactForm tags={[SupportMessageTags.OTHER]} />
        </HelpButton>
      </Row>
    </div>
  );
}
